import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./Turma.module.css";
import Alerta from "../../components/alerta/Alerta";
import BotaoNovo from "../../components/botaoNovo/BotaoNovo";
import { Button, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MdDelete, MdEdit, MdSearch, MdClose } from "react-icons/md";
import AlunoApi from "../../services/AlunoApi";
import Paginacao from "../../components/paginacao/Paginacao";
import TurmaApi from "../../services/TurmaApi";
import CursoMoodleApi from "../../services/CursoMoodleApi";
import Loader from "../../components/loader/Loader";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

function Turma() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

  useEffect(() => {
    setMenuHamburguerAberto(!isMobile);
  }, [isMobile]);

  //Modais para adicionar e excluir
  const [mostrarModalDeletar, setMostrarModalDeletar] = useState(false);
  const [mostrarModalAdicionar, setMostrarModalAdicionar] = useState(false);
  const [turmaSelecionada, setTurmaSelecionada] = useState(null);

  //Para exibir o alerta
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");

  //Para rodar a tabela, paginação e filtro
  const [turmas, setTurmas] = useState([]);

  const [quantidadeItens, setQuantidadeItens] = useState();
  const [nome, setNome] = useState("");
  const [periodo, setPeriodo] = useState(0);
  const [nomeFiltro, setNomeFiltro] = useState("");
  const [periodoFiltro, setPeriodoFiltro] = useState(0);
  const [paginaAtual, setPaginaAtual] = useState(1);

  //Para adicionar turma
  const [nomeAdicionar, setNomeAdicionar] = useState("");
  const [descricaoAdicionar, setDescricaoAdicionar] = useState("");
  const [periodoAdicionar, setPeriodoAdicionar] = useState(0);
  const [modalidadeAdicionar, setModalidadeAdicionar] = useState(0);
  const [cursoAdicionar, setCursoAdicionar] = useState(0);
  const [cursosMoodle, setCursosMoodle] = useState([]);

  const [statusTurmas, setStatusTurmas] = useState([]);
  const [peridoTurmas, setPeriodoTurmas] = useState([]);
  const [modalidadeTurmas, setModalidadeTurmas] = useState([]);

  const [loading, setLoading] = useState(false);

  //Função para filtro de busca
  async function BuscarTurmas() {
    setNome(nomeFiltro);
    setPeriodo(periodoFiltro);
    setPaginaAtual(1);
    await CarregarTurmas();
  }

  //Função para resetar  filtro de busca
  async function ResetarTurmas() {
    setNome("");
    setPeriodo(0);
    setNomeFiltro("");
    setPeriodoFiltro(0);
    setPaginaAtual(1);
    await CarregarTurmas();
  }

  //Função para alterar a página
  async function AlterarPagina(paginaNova) {
    setPaginaAtual(paginaNova);
    await CarregarTurmas();
  }

  //Função para abrir o modal de deletar
  const AbrirModalDeletar = (turma) => {
    setTurmaSelecionada(turma);
    setMostrarModalDeletar(true);
  };

  //Função para abrir o modal de adicionar
  const AbrirModalAdicionar = () => {
    LimparFormulario();
    setMostrarModalAdicionar(true);
  };

  //Função para deletar turma
  const BotaoDeletar = async () => {
    try {
      setLoading(true);
      await TurmaApi.deletarTurmaAsync(turmaSelecionada.turmaID);
      setTurmas(turmas.filter((t) => t.turmaID !== turmaSelecionada.turmaID));
      setMensagemAlerta(`Turma deletada com sucesso!`);
      setTipoAlerta("success");
      exibirAlerta(true);
    } catch (error) {
      setMensagemAlerta(`Erro ao deletar turma: ${error.response.data}`);
      setTipoAlerta("danger");
      exibirAlerta(true);
    } finally {
      FecharModal();
      setLoading(false);
    }
  };

  //Função para adicionar turma
  const AdicionarTurma = async () => {
    try {
      setLoading(true)
      await TurmaApi.criarTurmaComMoodleAsync(
        nomeAdicionar,
        descricaoAdicionar,
        periodoAdicionar,
        modalidadeAdicionar,
        cursoAdicionar
      );
      CarregarTurmas();
      setMensagemAlerta(`Turma adicionada com sucesso!`);
      setTipoAlerta("success");
      exibirAlerta(true);
    } catch (error) {
      setMensagemAlerta(`Erro ao adicionar turma: ${error.response.data}`);
      setTipoAlerta("danger");
      exibirAlerta(true);
    } finally {
      FecharModal();
      setLoading(false)
    }
  };

  //Função para o fechar modal
  const FecharModal = () => {
    setMostrarModalDeletar(false);
    setMostrarModalAdicionar(false);
    setTurmaSelecionada(null);
    LimparFormulario();
  };

  //Função para listar as turmas
  async function CarregarTurmas() {
    try {
      const listaTurmas = await TurmaApi.listarTurmasAsync(
        paginaAtual,
        nome,
        periodo
      );
      setQuantidadeItens(listaTurmas.quantidadeRegistros);
      setTurmas(listaTurmas.registros);

    } catch (error) {
      console.error("Erro ao carregar turmas:", error.response.data);
    }
  }

  //Função para obter todos os status de turma
  async function BuscarStatusTurma() {
    try {
      const status = await TurmaApi.listarStatusTurmasAsync();
      setStatusTurmas(status);
    } catch (error) {
      console.error("Erro ao buscar status da turma:", error.response.data);
    }
  }

  //Função para obter todas as modalidade de turma
  async function BuscarModalidadeTurma() {
    try {
      const modalidade = await TurmaApi.listarModalidadeTurmasAsync();
      setModalidadeTurmas(modalidade);
    } catch (error) {
      console.error("Erro ao buscar modalidade da turma:", error.response.data);
    }
  }

  //Função para obter todos os periodos de turma
  async function BuscarPeriodosTurma() {
    try {
      const periodos = await TurmaApi.listarPeriodoTurmasAsync();

      const periodosFormatados = periodos.map(p =>
        p.id === 1 ? { ...p, nome: "Manhã" } : p
      );

      setPeriodoTurmas(periodosFormatados);
    } catch (error) {
      console.error("Erro ao buscar periodo da turma:", error.response.data);
    }
  }

  //Função para obter todos os cursos do moodle
  async function BuscarCursosMoodle() {
    try {
      const listaCursos = await CursoMoodleApi.listarCursosMoodleAsync();
      setCursosMoodle(listaCursos);
    } catch (error) {
      console.error("Erro ao carregar cursos Moodle:", error.response?.data);
    }
  }

  const totalPaginas = Math.ceil(quantidadeItens / 10); //total de paginas com itens filtrados

  //Função para exibir o alerta
  const exibirAlerta = () => {
    setMostrarAlerta(true);
    setTimeout(() => {
      setMostrarAlerta(false);
    }, 10000);
  };

  const LimparFormulario = () => {
    setNomeAdicionar("");
    setDescricaoAdicionar("");
    setPeriodoAdicionar("");
    setModalidadeAdicionar("");
    setCursoAdicionar("");
  };

  useEffect(() => {
    async function carregarDados() {
      await Promise.all([
        BuscarStatusTurma(),
        BuscarPeriodosTurma(),
        BuscarModalidadeTurma(),
        BuscarCursosMoodle()
      ]);
    }

    carregarDados();
  }, []);

  useEffect(() => {
    CarregarTurmas();
  }, [paginaAtual, nome, periodo]);

  return (
    <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
      <Topbar
        menuHamburguerAberto={menuHamburguerAberto}
        setMenuHamburguerAberto={setMenuHamburguerAberto}
      >
        <Alerta
          tipo={tipoAlerta}
          mensagem={mensagemAlerta}
          visivel={mostrarAlerta}
          aoFechar={() => setMostrarAlerta(false)}
        />
        {loading && <Loader />}
        <div className={style.pagina_conteudo}>
          <div className={style.container_cabecalho}>
            <h4>Turmas</h4>
            <BotaoNovo link={AbrirModalAdicionar} />
          </div>

          {/* Filtro de pesquisa */}
          <div className={style.container_filtro}>
            <InputBuscar
              type="text"
              id="hidenNome"
              placeholder="Nome"
              name="nome"
              value={nomeFiltro}
              maxLength={25}
              onChange={(e) => setNomeFiltro(e.target.value)}
            />

            <Form.Select
              id="hidenPeriodo"
              name="periodo"
              value={periodoFiltro}
              onChange={(e) => setPeriodoFiltro(e.target.value)}
            >
              <option value="">Selecione o período</option>
              {peridoTurmas.map((periodo) => (
                <option key={periodo.id} value={periodo.id}>
                  {periodo.nome}
                </option>
              ))}
            </Form.Select>
            <div className={style.container_filtro2}>

              <Button onClick={BuscarTurmas} id={style.botao_buscar}>
                <MdSearch /> Buscar
              </Button>

              <Button onClick={ResetarTurmas} id={style.botao_resetar}>
                <MdClose /> Limpar
              </Button>
            </div>

          </div>

          {/* Tabela com paginação */}
          <div className={style.container_tabela_paginacao}>
            <div className={style.tabela_responsiva}>
              <table className={style.container_tabela}>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Periodo</th>
                    <th>Modalidade</th>
                    <th>Status</th>
                    <th>N° alunos</th>
                    <th className={style.coluna_acoes}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {turmas.map((turma) => (
                    <tr className={style.tabela_corpo} key={turma.turmaID}>
                      <td title={turma.nome}>{turma.nome}</td>
                      <td
                        title={
                          peridoTurmas.find((t) => t.id === turma.periodo)?.nome
                        }
                      >
                        {peridoTurmas.find((t) => t.id === turma.periodo)?.nome}
                      </td>
                      <td
                        title={
                          modalidadeTurmas.find(
                            (t) => t.id === turma.modalidade
                          )?.nome
                        }
                      >
                        {
                          modalidadeTurmas.find(
                            (t) => t.id === turma.modalidade
                          )?.nome
                        }
                      </td>
                      <td
                        title={
                          statusTurmas.find((t) => t.id === turma.status)?.nome
                        }
                      >
                        {statusTurmas.find((t) => t.id === turma.status)?.nome}
                      </td>
                      <td title={turma.quantidadeAlunos}>
                        {turma.quantidadeAlunos}
                      </td>
                      <td className={style.coluna_acoes}>
                        <Link
                          to="/editar/turma"
                          state={turma.turmaID}
                          className={style.botao_editar}
                        >
                          <MdEdit
                            title="Editar" />
                        </Link>
                        <Link
                          onClick={() => AbrirModalDeletar(turma)}
                          className={style.botao_deletar}
                        >
                          <MdDelete
                            title="Deletar" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Controle de Paginação */}
            <Paginacao
              id={style.configuracao_paginacao}
              paginaAtual={paginaAtual}
              totalPages={totalPaginas}
              onPageChange={(novaPagina) => AlterarPagina(novaPagina)}
            />
          </div>
          {/* Modal de confirmação para deletar turma */}
          <Modal show={mostrarModalDeletar} onHide={FecharModal}>
            <Modal.Header closeButton>
              <Modal.Title>Confirmar</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              Tem certeza que deseja deletar a turma {turmaSelecionada?.nome}?
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={FecharModal}>
                Cancelar
              </Button>
              <Button variant="danger" onClick={BotaoDeletar}>
                Deletar
              </Button>
            </Modal.Footer>
          </Modal>
          {/* Modal de adicionar turma */}
          <Modal show={mostrarModalAdicionar} onHide={FecharModal}>
            <Modal.Header closeButton>
              <Modal.Title>Adicionar nova turma</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Form.Group controlId="formNome" className="mb-3">
                <Form.Label>Nome</Form.Label>
                <InputBuscar
                  maxLength={100}
                  type="text"
                  placeholder="Digite o nome"
                  name="nome"
                  value={nomeAdicionar}
                  onChange={(e) => setNomeAdicionar(e.target.value)}
                  required
                />
              </Form.Group>
              <Form.Group controlId="formDescricao" className="mb-3">
                <Form.Label>Descrição</Form.Label>
                <InputBuscar
                  maxLength={100}
                  as="textarea"
                  placeholder="Digite a descrição"
                  name="descricao"
                  value={descricaoAdicionar}
                  onChange={(e) => setDescricaoAdicionar(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group controlId="formPeriodo" className="mb-3">
                <Form.Label>Período</Form.Label>
                <Form.Control
                  as="select"
                  name="Periodo"
                  value={periodoAdicionar}
                  onChange={(e) => setPeriodoAdicionar(e.target.value)}
                  required
                >
                  <option value="">Selecione o período</option>
                  {peridoTurmas.map((periodo) => (
                    <option key={periodo.id} value={periodo.id}>
                      {periodo.nome}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              <Form.Group controlId="formModalidade" className="mb-3">
                <Form.Label>Modalidade</Form.Label>
                <Form.Control
                  as="select"
                  name="Modalidade"
                  value={modalidadeAdicionar}
                  onChange={(e) => setModalidadeAdicionar(e.target.value)}
                  required
                >
                  <option value="">Selecione a modalidade</option>
                  {modalidadeTurmas.map((modalidade) => (
                    <option key={modalidade.id} value={modalidade.id}>
                      {modalidade.nome}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              <Form.Group controlId="formCursoMoodle" className="mb-3">
                <Form.Label>Curso Moodle</Form.Label>

                <Form.Control
                  as="select"
                  name="CursoMoodle"
                  value={cursoAdicionar}
                  onChange={(e) => setCursoAdicionar(e.target.value)}
                  required
                >
                  <option value="">Selecione o curso</option>

                  {cursosMoodle.map((curso) => (
                    <option key={curso.courseId} value={curso.courseId}>
                      {curso.nome}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary " onClick={FecharModal}>
                Cancelar
              </Button>
              <Button variant="success" onClick={AdicionarTurma}>
                Adicionar
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </Topbar>
    </Sidebar>
  );
}

export default Turma;
